export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="mb-8">
              <p className="text-teal-600 text-sm font-semibold mb-2 tracking-wider">ABOUT US</p>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight whitespace-nowrap">快適な街造りに貢献する<strong>南場組</strong></h2>
            </div>
            <div className="space-y-6 text-gray-700 leading-relaxed text-xl">
              <p>
                <strong>株式会社南場組</strong>は総合建設業として<strong>土木工事</strong>を仕事としています。<br />
                道路や田んぼに水を運ぶ用水路などを新しく造ったり、老朽化した物を修繕しています。<br />
                新潟市や亀田郷土地改良区から発注の工事を受注し、元請けとして施工を実施します。<br />
                創業以来７０年以上、道路、<strong>下水道工事</strong>、<strong>用水路工事</strong>、排水路の工事を行っているので施工実績が豊富です。<br />
                主に<strong>新潟市江南区</strong>内(旧亀田町)での施工なので地域住民との交流もあり、仕事を通して地域貢献しています。<br />
                会社内も地元ともでコミュニケーションがとれていて、時に真剣に、時に笑顔で仕事に取り組んでいる会社です。
              </p>
            </div>
          </div>

          <div className="relative h-full">
            <div className="h-full w-full overflow-hidden rounded-lg shadow-2xl">
              <img
                src="https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/007a8d587b77ad81e6cb65249c37a5a7.png"
                alt="株式会社南場組 会社概要 新潟市江南区早通の総合建設業"
                title="株式会社南場組 土木工事 舗装工事"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-20 grid md:grid-cols-2 gap-8">
          <div className="bg-gray-50 p-10 rounded-lg">
            <div className="w-14 h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-building-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">会社名</h3>
            <div className="text-gray-700 space-y-4">
              <p className="font-semibold text-xl"><strong>株式会社南場組</strong></p>
              <div className="text-base space-y-3 pt-3 border-t border-gray-200">
                <p className="font-semibold">◎創業</p>
                <p className="pl-4">昭和２４年(１９４９年) ３月２０日</p>
                <p className="font-semibold">◎設立</p>
                <p className="pl-4">昭和３３年(１９５８年) ９月９日</p>
                <p className="font-semibold">◎代表</p>
                <p className="pl-4">代表取締役 南場 栄司</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-10 rounded-lg">
            <div className="w-14 h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-map-pin-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">所在地</h3>
            <p className="text-gray-700 text-lg leading-relaxed">〒950-0168<br /><strong>新潟市江南区早通</strong>4丁目1番21号</p>
          </div>

          <div className="bg-gray-50 p-10 rounded-lg">
            <div className="w-14 h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-hammer-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">事業内容</h3>
            <div className="text-gray-700 space-y-3">
              <p className="font-semibold text-lg">◎建設業の許可業種</p>
              <p className="text-base">新潟県知事許可（特-４）第２１８１号</p>
              <p className="text-base"><strong>土木工事業</strong> とび・土工工事事業</p>
              <p className="text-base"><strong>舗装工事業</strong> 水道施設工事業</p>
            </div>
          </div>

          <div className="bg-gray-50 p-10 rounded-lg">
            <div className="w-14 h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-team-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">主な加盟団体</h3>
            <div className="text-gray-700 text-base space-y-3">
              <p>新潟県建設業協会</p>
              <p>亀田郷建設業協会</p>
              <p>亀田建設業協会</p>
              <p>江南区災害防止協議会</p>
              <p>亀田商工会議所</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}